firebird.controller('sidebarLeftCtrl', [
    'helperService',
    '$rootScope',
    '$scope',
    '$state',
    '$document',
    '$timeout',
    '$interval',
    '$window',
    'notificationService',
    'meetingService',
    'analyticsWrapperService',
    'logService',
    'attendeeService',
    'meetingNotesService',
    'annotationService',
    'localizationService',
    'joinRequestNotificationService',
    'growlService',
    'socketService',
    'vdiService',
    'leftSideBarStateService',
    function (
        helperService,
        $rootScope,
        $scope,
        $state,
        $document,
        $timeout,
        $interval,
        $window,
        notificationService,
        meetingService,
        analyticsWrapperService,
        logService,
        attendeeService,
        meetingNotesService,
        annotationService,
        localizationService,
        joinRequestNotificationService,
        growlService,
        socketService,
        vdiService,
        leftSideBarStateService
    ) {
        var self = this;

        const logger = new LogServiceWrapper(logService, 'sidebarLeftCtrl');

        self.isMsgAutoGenerated = isMsgAutoGenerated;
        self.isChatTabActive = isChatTabActive;
        self.isPresenterChatTabActive = isPresenterChatTabActive;

        self.createChatNotification = createChatNotification;
        self.createPresenterChatNotification = createPresenterChatNotification;
        self.isPageHidden = false;
        self.pageHiddenMessageCount = 0;
        self.pageHiddenPresenterMessageCount = 0;
        self.documentTitleMessageCount = '';

        self.unreadChatCount = '0';
        self.checkUnreadCounts = checkUnreadCounts;
        self.clearUnreadChatCounts = clearUnreadChatCounts;
        self.hasUnreadPrivateChat = false;

        self.unreadPresenterChatCount = '0';
        self.checkUnreadPresenterCounts = checkUnreadPresenterCounts;

        self.unreadMeetingNotes = false;
        self.checkUnreadMeetingNotes = checkUnreadMeetingNotes;

        self.handleVisibilityChange = handleVisibilityChange;

        self.onMeetingStateV2Updated = onMeetingStateV2Updated;
        self.state = 'attendee-list';

        self.hasMeetingNote = hasMeetingNote;
        self.meetingNotesAllowed = meetingNotesAllowed;
        self.getNotesTooltipMessage = getNotesTooltipMessage;
        self.hasAttendeeList = hasAttendeeList;
        self.hasChat = hasChat;
        self.hasPresenterChat = hasPresenterChat;
        self.canUseMeetingChat = canUseMeetingChat;
        self.getChatTooltipMessage = getChatTooltipMessage;

        self.isAttendeeListVisibleToAttendees = isAttendeeListVisibleToAttendees;
        self.isChatVisibleToAttendees = isChatVisibleToAttendees;

        //Tab-related functions
        self.showTab = showTab;
        self.getVisibleTabs = getVisibleTabs;
        self.isTabActive = isTabActive;
        self.syncActiveTabState = syncActiveTabState;

        self.toggleSidebarJS = toggleSidebarJS;

        self.meetingNoteReminderIsOpen = false;
        self.meetingNoteReminderShown = false;
        self.disableMeetingNoteNotice = false;
        self.isVisible = isVisible;
        self.onCloseMeetingNoteNotice = onCloseMeetingNoteNotice;
        self.applyPopOverControlHandler = applyPopOverControlHandler;
        self.onToggleDisableMeetingNoteCheck = onToggleDisableMeetingNoteCheck;

        self.shouldShowDuration = false;
        self.durationText = '';
        self.getRemainingDurationText = getRemainingDurationText;
        self.getDurationPercentage = getDurationPercentage;
        self.showDurationWarning = showDurationWarning;
        self.setInitialDurationText = setInitialDurationText;
        self.totalSeconds = 0;
        self.remainingSeconds = 0;
        self.setupDurationTimer = setupDurationTimer;
        self.durationInterval = null;
        self.showFirstPastImage = showFirstPastImage;
        self.showSecondPastImage = showSecondPastImage;
        self.getScheduledDurationLabel = getScheduledDurationLabel;
        self.hasNewJoinRequests = false;
        self.hasNewRaisedHands = false;
        self.shouldShowNotificationBadgeOnAttendeesTab = shouldShowNotificationBadgeOnAttendeesTab;
        self.onHandRaised = onHandRaised;
        self.onRaisedHandsUpdated = onRaisedHandsUpdated;
        self.showNewJoinRequestsPopover = false;
        self.onJoinRequestPopoverClicked = onJoinRequestPopoverClicked;
        self.onJoinRequestPopoverClose = onJoinRequestPopoverClose;
        self.onJoinRequestsUpdate = onJoinRequestsUpdate;
        self.onUpdateLocalMeetingLocked = onUpdateLocalMeetingLocked;
        self.onE2EEEnabled = onE2EEEnabled;
        self.onNotifyMeetingChatMessagesCleared = onNotifyMeetingChatMessagesCleared;

        self.changeNotesRecipients = changeNotesRecipients;
        self.notesToAllAttendees = meetingService.getNotesRecipients() === 'all';
        self.onNotesRecipientsChanged = onNotesRecipientsChanged;
        self.getNotesRecipientsAttendeeTooltip = getNotesRecipientsAttendeeTooltip;
        self.getIsHost = getIsHost;

        self.initMeetingNotesPopover = initMeetingNotesPopover;
        self.isAttendeeListVisible = isAttendeeListVisible;
        self.updateTitle = updateTitle;

        //Custom branding
        self.inMeetingLogo = '';
        self.getAppLogoURL = meetingService.getAppLogoURL;

        //Read the method comments if you want to use this
        self.setSeconds = setSeconds;

        self.attendeeCount = 1;

        self.isCompactMode = false;

        $document.on('visibilitychange', handleVisibilityChange);

        $scope.$on('chat-message', function (event, receivedChatMessageObject) {
            if (!receivedChatMessageObject) {
                logger.error('chat-message', 'chat event received but no chat obj available');
                return;
            }

            var isIncomingMsgPrivate = !!receivedChatMessageObject.isPrivate;

            self.checkUnreadCounts(isIncomingMsgPrivate);
            self.createChatNotification(receivedChatMessageObject);
        });

        $scope.$on('presenter-chat-message', function (event, receivedChatMessageObject) {
            self.checkUnreadPresenterCounts();
            self.createPresenterChatNotification(receivedChatMessageObject);
        });

        $scope.$on('meeting-notes-message', function (event, receivedChatMessageObject) {
            self.checkUnreadMeetingNotes();
        });

        $scope.$on('meeting-state-v2', self.onMeetingStateV2Updated);

        $scope.$on('cleared-meeting-chat-messages', function () {
            self.clearUnreadChatCounts();

            // reset document title in case there was a number of unread messages
            self.updateTitle();
        });

        // if current tab is meeting chat and host disabled it we need to switch attendee to another one
        // and show a popup to attendee with description of the reason
        $rootScope.$on('meeting-chat-disabled', function () {
            if (!meetingService.isWebinar() && self.isTabActive('chat')) {
                self.showTab('attendee-list');

                if (!attendeeService.getIsHost()) {
                    $rootScope.$broadcast('notify-of-security-change');
                }
            }
        });

        $rootScope.$on('chat-desktop-notification-onclick', function () {
            self.showTab('chat');
        });

        $rootScope.$on('presenter-chat-desktop-notification-onclick', function () {
            self.showTab('presenter-chat');
        });

        $rootScope.$on('join-request-list-desktop-notification-onclick', function () {
            self.onJoinRequestPopoverClicked();
        });

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            if (toState.name === 'meeting-active.chat-client') {
                $scope.$apply(function () {
                    self.clearUnreadChatCounts();
                    self.documentTitleMessageCount = '0';
                    self.updateTitle();
                });
            } else if (toState.name === 'meeting-active.presenter-chat-client') {
                $scope.$apply(function () {
                    self.unreadPresenterChatCount = '0';
                    self.documentTitleMessageCount = '0';
                    self.updateTitle();
                });
            } else if (toState.name === 'meeting-active.firepad') {
                $scope.$apply(function () {
                    self.unreadMeetingNotes = false;
                    self.meetingNoteReminderShown = true;
                    self.onCloseMeetingNoteNotice();
                    // self.updateTitle();
                });
            } else if (toState.name === 'meeting-active.attendee-list') {
                $scope.$apply(function () {
                    self.hasNewJoinRequests = false;
                    self.showNewJoinRequestsPopover = false;
                    self.hasNewRaisedHands = false;
                });
            }
        });

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            if ($state.includes('meeting-active.attendee-list')) {
                self.state = 'attendee-list';
                analyticsWrapperService.eventTrack('meeting - sidebar - user activated attendee-list tab', {
                    category: 'sidebar'
                });
            } else if ($state.includes('meeting-active.firepad')) {
                self.state = 'firepad';
                analyticsWrapperService.eventTrack('meeting - sidebar - user activated meeting note tab', {
                    category: 'sidebar'
                });
            } else if ($state.includes('meeting-active.presenter-chat-client')) {
                self.state = 'presenter-chat-client';
                analyticsWrapperService.eventTrack('meeting - sidebar - user activated presenter-chat-client tab', {
                    category: 'sidebar'
                });

                // $timeout is required here so that the event 'onShowChatTab'
                // is broadcast after the DOM has been manipulated by Angular, and after the browser renders
                $timeout(function () {
                    $rootScope.$broadcast('onShowPresenterChatTab');
                });
            } else if ($state.includes('meeting-active.chat-client')) {
                self.state = 'chat-client';
                analyticsWrapperService.eventTrack('meeting - sidebar - user activated chat-client tab', {
                    category: 'sidebar'
                });

                // $timeout is required here so that the event 'onShowChatTab'
                // is broadcast after the DOM has been manipulated by Angular, and after the browser renders
                $timeout(function () {
                    $rootScope.$broadcast('onShowChatTab');
                });
            }

            leftSideBarStateService.activeTab = self.state;
        });

        // if current tab is notes and host disabled it we need to switch attendee to another one
        // and show a popup to attendee with description of the reason
        $rootScope.$on('meeting-notes-disabled', function () {
            self.unreadMeetingNotes = false;
            if (self.isTabActive('meeting-notes')) {
                self.showTab('attendee-list');
                if (!attendeeService.getIsHost()) {
                    $rootScope.$broadcast('notify-of-security-change');
                }
            }
        });

        $scope.$on('on-air-mode-updated', onOnAirModeUpdated);
        $scope.$on('webinar-options-updated', onWebinarOptionsUpdated);
        $scope.$on('attendee-type-updated', onAttendeeTypeUpdated);
        $scope.$on('branding-info-updated', onBrandingInfoUpdated);
        $scope.$on('hide-modal', onHideModal);
        $scope.$on('on-join-requests-update', onJoinRequestsUpdate);
        $scope.$on('update-local-meeting-locked', onUpdateLocalMeetingLocked);
        $scope.$on('notify-meeting-chat-messages-cleared', onNotifyMeetingChatMessagesCleared);

        $scope.$on('attendee-list-updated', onAttendeeListUpdated);
        // when side bar is resized, adjust content and footer left too.
        $scope.$on('angular-resizable.resizeEnd', function () {
            if (meetingService.getIsSfuEnabled()) {
                logService.log('sidebar resize end, adjusting meeting content size.');
                var left = $window.$('#sidebar-left').width();
                if (left) {
                    $window.$('#meetingContent').css('left', left + 'px');
                    $window.$('#header #footer-menu').css('left', left + 'px');
                }
            }
        });

        $scope.$on('e2ee-enabled', self.onE2EEEnabled);
        $scope.$on('notes-recipients-updated', self.onNotesRecipientsChanged);
        $rootScope.$on('enable-compact-mode', onCompactModeReceived);

        $scope.$on('hand-raised', self.onHandRaised);
        $scope.$on('raised-hands-updated', self.onRaisedHandsUpdated);

        init();

        ////////////////////////

        function init() {
            if (userIsAttendeeOnAir()) {
                self.syncActiveTabState();
            }

            self.setupDurationTimer();

            // Custom branding
            var brandingInfo = meetingService.getBrandingInfo();
            if (brandingInfo && brandingInfo.inMeetingLogoURL) {
                self.inMeetingLogo = brandingInfo.inMeetingLogoURL;
                digest();
            }

            if (!meetingService.shouldShowDeviceSelectionPreview()) {
                self.initMeetingNotesPopover();
            }
            //else, will init Notes popover on device-selection modal-close event

            if (meetingService.getLocked() && attendeeService.getIsHost()) {
                joinRequestNotificationService.start();
            }
        }

        function initMeetingNotesPopover() {
            $timeout(function () {
                if (
                    attendeeService.getIsHost() &&
                    !meetingService.isWebinar() &&
                    !helperService.isMobile() &&
                    !helperService.isFullScreen()
                ) {
                    var disabled =
                        self.showNewJoinRequestsPopover ||
                        !self.meetingNotesAllowed() ||
                        self.meetingNoteReminderShown ||
                        !self.isVisible() ||
                        $window.localStorage.getItem('should-disable-meetingnote-notice');
                    var shouldShowMeetingNoteNotice = disabled === 'true' || disabled === true ? false : true;
                    if (shouldShowMeetingNoteNotice) {
                        self.meetingNoteReminderIsOpen = true;
                        var popover = $window.$('.meeting-note-tab').popover({
                            container: 'body',
                            html: true,
                            trigger: 'manual',
                            content: $('#meetingNoteNoticePopoverContent').html()
                        });
                        if (popover.data('bs.popover') && popover.data('bs.popover').tip) {
                            popover.data('bs.popover').tip().addClass('meeting-note-popover');
                        }
                        $window.$('.meeting-note-tab').popover('show');
                        self.applyPopOverControlHandler();

                        $timeout(function () {
                            self.onCloseMeetingNoteNotice();
                        }, 1000 * 60);
                    }
                }
            }, 1000 * 60 * 5);
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('deviceSelection') !== -1) {
                self.initMeetingNotesPopover();
            }
        }

        function onBrandingInfoUpdated() {
            var data = meetingService.getBrandingInfo();
            self.inMeetingLogo = data.inMeetingLogoURL;
            digest();
        }

        function setupDurationTimer() {
            var cal = meetingService.getCalendarTimerInfo();

            if (!cal) {
                return;
            }
            logService.log('setting up calendar duration information');
            self.shouldShowDuration = true;

            var start = cal.startTime;
            var end = cal.endTime;
            var current = cal.currentTime;

            self.totalSeconds = (end.getTime() - start.getTime()) / 1000;
            self.remainingSeconds = (end.getTime() - current.getTime()) / 1000;

            self.durationInterval = $interval(function () {
                self.remainingSeconds -= 30;
            }, 30000);

            self.setInitialDurationText(start, end);
        }

        //TODO: This is purely a function for testing and this should never be called by active code
        function setSeconds(sec) {
            if (sec) {
                self.remainingSeconds = sec;
            }
        }

        function getScheduledDurationLabel() {
            return self.remainingSeconds <= -36000
                ? localizationService.translate('ATTENDEE_LIST.SCHEDULED.DURATION', { time: self.durationText })
                : localizationService.translate('ATTENDEE_LIST.SCHEDULED.DURATION', { time: self.durationText });
        }

        function showDurationWarning() {
            if (self.totalSeconds >= 3600) {
                if (self.remainingSeconds < 600) {
                    return true;
                }
                return false;
            }

            var threshold = Math.round(self.totalSeconds * 0.1666666667); //  1/6
            if (self.remainingSeconds < threshold) {
                return true;
            }

            return false;
        }

        function getDurationPercentage() {
            if (self.remainingSeconds < 0) {
                return 100;
            }
            return Math.round(((self.totalSeconds - self.remainingSeconds) / self.totalSeconds) * 100);
        }

        function showFirstPastImage() {
            if (self.remainingSeconds <= -300 && self.remainingSeconds > -600) {
                return true;
            }

            return false;
        }

        function showSecondPastImage() {
            if (self.remainingSeconds <= -600) {
                return true;
            }

            return false;
        }

        function getRemainingDurationText() {
            return formatRemaining(Math.floor(self.remainingSeconds / 60));
        }

        function setInitialDurationText(start, end) {
            var totalMinutes = (end.getTime() - start.getTime()) / 1000 / 60;

            self.durationText = formatInitialDuration(totalMinutes);
        }

        function formatRemaining(minutes) {
            var isNegative = minutes < 0;

            if (minutes === 0) {
                return localizationService.translate('ATTENDEE_LIST.SCHEDULED.TIME_IS_UP');
            }

            if (isNegative) {
                minutes = minutes * -1;
            }
            var displayHours = Math.floor(minutes / 60);
            var displayMinutes = minutes % 60;
            var finalDisplay = '';

            if (displayHours > 0) {
                finalDisplay = localizationService.translate('ATTENDEE_LIST.SCHEDULED.HOURS', { hours: displayHours });
                if (displayMinutes > 0) {
                    finalDisplay += ' ';
                }
            }

            if (displayMinutes > 0) {
                finalDisplay += localizationService.translate('ATTENDEE_LIST.SCHEDULED.MINUTES', {
                    minutes: displayMinutes
                });
            }

            if (isNegative) {
                finalDisplay = localizationService.translate('ATTENDEE_LIST.SCHEDULED.OVERTIME', {
                    time: finalDisplay
                });
                finalDisplay += displayMinutes < 5 ? '!' : ' ';
            } else {
                finalDisplay =
                    displayHours === 0 && displayMinutes < 5
                        ? localizationService.translate('ATTENDEE_LIST.SCHEDULED.TIME_LEFT_HURRY', {
                              time: finalDisplay
                          })
                        : localizationService.translate('ATTENDEE_LIST.SCHEDULED.TIME_LEFT', { time: finalDisplay });
            }

            return finalDisplay;
        }

        function formatInitialDuration(minutes) {
            var isNegative = minutes < 0;
            if (isNegative) {
                minutes = minutes * -1;
            }
            var displayHours = Math.floor(minutes / 60);
            var displayMinutes = minutes % 60;
            var finalDisplay = '';

            if (displayHours > 0) {
                finalDisplay = localizationService.translate('ATTENDEE_LIST.SCHEDULED.HOURS', { hours: displayHours });
                if (displayMinutes > 0) {
                    finalDisplay += ' ';
                }
            }

            if (displayMinutes > 0) {
                finalDisplay += localizationService.translate('ATTENDEE_LIST.SCHEDULED.MINUTES', {
                    minutes: displayMinutes
                });
            }

            if (isNegative) {
                finalDisplay = '-' + finalDisplay;
            }
            return finalDisplay;
        }

        function applyPopOverControlHandler() {
            var closeBtn = $window.$('.popover .show-meeting-note-notice-popover-close-btn i');
            if (closeBtn) {
                closeBtn.click(self.onCloseMeetingNoteNotice);
            }

            var link = $window.$('.popover .show-meeting-note-notice-popover-label');
            if (link) {
                link.click(self.onToggleDisableMeetingNoteCheck);
            }
        }

        function onToggleDisableMeetingNoteCheck() {
            localStorage.setItem('should-disable-meetingnote-notice', true);
            self.onCloseMeetingNoteNotice();
        }

        function onCloseMeetingNoteNotice() {
            $('.meeting-note-tab').popover('hide');
        }

        function toggleSidebarJS() {
            let sideBarElement = angular.element('#sidebar-left')[0];
            if (!sideBarElement) {
                logger.log('toggleSidebarJS', 'sideBarElement is not defined');
                return;
            }

            if (sideBarElement.className.indexOf('toggled') < 0) {
                if (helperService.shouldSidebarCollapse()) {
                    helperService.setMinimizedSideBarClickedState(true);
                }
                leftSideBarStateService.isOpen = true;
                helperService.setSideBarClickedState(true);
                $rootScope.$broadcast('toggle-left-sidebar', 'open');
                self.onCloseMeetingNoteNotice();

                if (self.isTabActive('attendee-list')) {
                    self.showNewJoinRequestsPopover = false;
                    self.hasNewJoinRequests = false;
                    self.hasNewRaisedHands = false;
                }
            } else {
                if (helperService.shouldSidebarCollapse()) {
                    helperService.setMinimizedSideBarClickedState(false);
                }
                leftSideBarStateService.isOpen = false;
                helperService.setSideBarClickedState(false);
                $rootScope.$broadcast('toggle-left-sidebar', 'closed');
            }

            annotationService.clearCanvas();
        }

        function isVisible() {
            return helperService.isLeftSidebarVisible();
        }

        function onMeetingStateV2Updated(e, options) {
            logService.log('sidebarLeftCtrl - Meeting State V2 Updated: ' + options.state);
            switch (options.state) {
                case 'ending':
                    self.onCloseMeetingNoteNotice();
                    self.clearUnreadChatCounts();
                    self.unreadPresenterChatCount = '0';
                    self.pageHiddenMessageCount = 0;
                    self.pageHiddenPresenterMessageCount = 0;
                    self.documentTitleMessageCount = '0';
                    self.updateTitle();
                    break;
            }
        }

        function handleVisibilityChange() {
            self.isPageHidden = $document[0].hidden;
            if (!self.isPageHidden) {
                self.pageHiddenMessageCount = 0;
                self.pageHiddenPresenterMessageCount = 0;
                if (self.isChatTabActive()) {
                    self.documentTitleMessageCount = '0';
                    self.updateTitle();
                }
                if (meetingService.isWebinar() && self.isPresenterChatTabActive()) {
                    self.documentTitleMessageCount = '0';
                    self.updateTitle();
                }
            }
        }

        function checkUnreadMeetingNotes() {
            if ($state.current.name !== 'meeting-active.firepad') {
                if (self.meetingNotesAllowed()) {
                    if (self.unreadMeetingNotes !== true) {
                        self.unreadMeetingNotes = true;

                        $scope.$apply(function () {
                            self.unreadMeetingNotes = true;
                        });
                    }
                }
            }
        }

        function checkUnreadPresenterCounts() {
            if (self.isPageHidden) {
                self.pageHiddenPresenterMessageCount += 1;
                var count =
                    self.pageHiddenPresenterMessageCount > 9 ? '9+' : self.pageHiddenPresenterMessageCount.toString();
                self.documentTitleMessageCount = count;
            }
            if (!self.isPresenterChatTabActive()) {
                var currentCount = parseInt(self.unreadPresenterChatCount.replace('+', ''));
                currentCount++;

                if (currentCount > 9) {
                    currentCount = '9+';
                }

                $scope.$apply(function () {
                    self.unreadPresenterChatCount = currentCount + '';
                    self.documentTitleMessageCount = self.unreadPresenterChatCount;
                });
            }

            $scope.$apply(function () {
                var shouldShowChatCount = parseInt(self.documentTitleMessageCount.replace('+', '')) > 0;
                var title = getWindowMeetingTitle();
                var titleText = shouldShowChatCount ? '(' + self.documentTitleMessageCount + ') ' + title : title;

                if (helperService.getVDIRef().showCustomTitleBar) {
                    vdiService.setVDITitleBarHeader(titleText);
                } else {
                    $document[0].title = titleText;
                }
            });
        }

        function checkUnreadCounts(isIncomingMsgPrivate) {
            if (self.isPageHidden) {
                self.pageHiddenMessageCount += 1;
                var count = self.pageHiddenMessageCount > 9 ? '9+' : self.pageHiddenMessageCount.toString();
                self.documentTitleMessageCount = count;
            }
            if (!self.isChatTabActive()) {
                var currentCount = parseInt(self.unreadChatCount.replace('+', ''));
                currentCount++;

                if (isIncomingMsgPrivate && !self.hasUnreadPrivateChat) {
                    self.hasUnreadPrivateChat = true;
                }

                if (currentCount > 9) {
                    currentCount = '9+';
                }

                $scope.$apply(function () {
                    self.unreadChatCount = currentCount + '';
                    self.documentTitleMessageCount = self.unreadChatCount;
                });
            }

            $scope.$apply(function () {
                var shouldShowChatCount = parseInt(self.documentTitleMessageCount.replace('+', '')) > 0;
                var title = getWindowMeetingTitle();
                var titleText = shouldShowChatCount ? '(' + self.documentTitleMessageCount + ') ' + title : title;

                if (helperService.getVDIRef().showCustomTitleBar) {
                    vdiService.setVDITitleBarHeader(titleText);
                } else {
                    $document[0].title = titleText;
                }
            });
        }

        function clearUnreadChatCounts() {
            self.unreadChatCount = '0';
            self.hasUnreadPrivateChat = false;
            digest();
        }

        function isMsgAutoGenerated(msgObj) {
            return msgObj.autoGenerated || msgObj.appGenerated || msgObj.notification;
        }

        function isChatTabActive() {
            return self.state === 'chat-client';
        }

        function isPresenterChatTabActive() {
            return self.state === 'presenter-chat-client';
        }

        function createChatNotification(chatMessageObject) {
            if (self.isMsgAutoGenerated(chatMessageObject)) {
                return;
            }

            if (
                !self.isChatTabActive() ||
                !self.isVisible() ||
                !helperService.isBrowserInFocus() ||
                self.isCompactMode
            ) {
                if (meetingService.isWebinar()) {
                    notificationService.show(
                        chatMessageObject.message,
                        'chat',
                        localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.MESSAGE_FROM_PERSON', {
                            person: chatMessageObject.name
                        })
                    );
                } else {
                    if (chatMessageObject.isPrivate) {
                        notificationService.show(
                            chatMessageObject.message,
                            'chat',
                            localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.PRIVATE_MESSAGE_FROM_PERSON', {
                                person: chatMessageObject.name
                            })
                        );
                    } else {
                        notificationService.show(chatMessageObject.message, 'chat', chatMessageObject.name);
                    }
                }
            }
        }

        function createPresenterChatNotification(chatMessageObject) {
            if (self.isMsgAutoGenerated(chatMessageObject)) {
                return;
            }

            if (!self.isPresenterChatTabActive() || !self.isVisible() || !helperService.isBrowserInFocus()) {
                notificationService.show(
                    chatMessageObject.message,
                    'presenter-chat',
                    'Message from ' + chatMessageObject.name
                );
            }
        }

        function getWindowMeetingTitle() {
            var re = /^(\(\d+\)|\(9\+\)) /;
            var title;
            if (helperService.getVDIRef().showCustomTitleBar) {
                title = vdiService.getVDITitleBarHeader();
            } else {
                title = $document[0].title;
            }
            if (title.match(re) != null) {
                title = title.replace(re, '');
            }

            return title;
        }

        function hasAttendeeList() {
            if (meetingService.isWebinar()) {
                if (attendeeService.getIsPresenter()) {
                    return true;
                } else {
                    return meetingService.isAttendeeListVisibleToAttendees();
                }
            } else {
                return true;
            }
        }

        function isAttendeeListVisibleToAttendees() {
            return meetingService.isAttendeeListVisibleToAttendees();
        }

        function hasChat() {
            if (meetingService.isWebinar()) {
                if (attendeeService.getIsPresenter()) {
                    return true;
                } else {
                    return meetingService.getWebinarOptions().showPublicChat;
                }
            } else {
                return true;
            }
        }

        function hasPresenterChat() {
            if (meetingService.isWebinar() && attendeeService.getIsPresenter()) {
                return true;
            }

            return false;
        }

        function isChatVisibleToAttendees() {
            return meetingService.getWebinarOptions().showPublicChat;
        }

        function hasMeetingNote() {
            return meetingNotesService.hasMeetingNotes();
        }

        function meetingNotesAllowed() {
            return meetingNotesService.canUseMeetingNotes();
        }

        function getNotesTooltipMessage() {
            if (this.meetingNotesAllowed()) {
                return '';
            }

            if (meetingService.e2eeEnabled()) {
                return localizationService.translate('SECURITY_SETTINGS.TOOLTIP.E2EE_NOTES_DISABLED');
            }

            var tooltipKey = attendeeService.getIsHost()
                ? 'SIDEBAR.HOST_DISABLED_NOTES_HOST_TOOLTIP'
                : 'SIDEBAR.HOST_DISABLED_NOTES_TOOLTIP';
            return localizationService.translate(tooltipKey);
        }

        function getVisibleTabs() {
            var visibleTabs = [];

            if (self.hasAttendeeList()) {
                visibleTabs.push('attendee-list');
            }

            if (self.hasPresenterChat()) {
                visibleTabs.push('presenter-chat');
            }

            if (self.hasChat()) {
                visibleTabs.push('chat');
            }

            if (self.hasMeetingNote()) {
                visibleTabs.push('meeting-notes');
            }

            return visibleTabs;
        }

        function isTabActive(tabName) {
            var isActive = false;

            switch (tabName) {
                case 'attendee-list':
                    isActive = self.state === 'attendee-list' && self.hasAttendeeList();
                    break;
                case 'chat':
                    isActive = self.state === 'chat-client' && self.hasChat();
                    break;
                case 'presenter-chat':
                    isActive = self.state === 'presenter-chat-client' && self.hasPresenterChat();
                    break;
                case 'meeting-notes':
                    isActive = self.state === 'firepad' && self.hasMeetingNote();
                    break;
            }

            return isActive;
        }

        function onWebinarOptionsUpdated() {
            if (userIsAttendeeOnAir()) {
                self.syncActiveTabState();
            }
        }

        function onOnAirModeUpdated() {
            if (userIsAttendeeOnAir()) {
                self.syncActiveTabState();
            }
        }

        function onAttendeeTypeUpdated() {
            if (userIsAttendeeOnAir()) {
                self.syncActiveTabState();
            }
        }

        function showTab(tabName) {
            logService.log('Left Sidebar - Showing new tab:', tabName);

            //If in the middle of a digest cycle,
            //$state.go will error...
            //
            //By placing the calls in a timeout, they will
            //be run after the current digest cycle
            switch (tabName) {
                case 'attendee-list':
                    $timeout(function () {
                        $state.go('meeting-active.attendee-list');
                    });
                    break;
                case 'chat':
                    if (self.canUseMeetingChat()) {
                        $timeout(function () {
                            $state.go('meeting-active.chat-client');
                        });
                    }
                    break;
                case 'presenter-chat':
                    $timeout(function () {
                        $state.go('meeting-active.presenter-chat-client');
                    });
                    break;
                case 'meeting-notes':
                    $timeout(function () {
                        $state.go('meeting-active.firepad');
                    });
                    break;
                default:
                    logger.error('showTab', 'Unable to show new tab', tabName);
            }
        }

        //When tabs get hidden/shown (webinars only),
        //we want to make sure the sidebar shows the correct view
        function syncActiveTabState() {
            var visibleTabs = self.getVisibleTabs();
            var tabsOutOfSync = false;

            if (visibleTabs.length === 0) {
                logService.log('No tabs visible, returning from syncActiveTabState');
                return;
            }

            //If current tab is not visible,
            //sync state with the next available tab
            switch (self.state) {
                case 'attendee-list':
                    tabsOutOfSync = !self.hasAttendeeList();
                    break;
                case 'chat-client':
                    tabsOutOfSync = !self.hasChat();
                    break;
                case 'presenter-chat-client':
                    tabsOutOfSync = !self.hasPresenterChat();
                    break;
                case 'firepad':
                    tabsOutOfSync = !self.hasMeetingNote();
                    break;
                default:
                    logger.error('syncActiveTabState', 'Unable to set active tab state', self.state);
            }

            if (tabsOutOfSync) {
                logService.log('Left Sidebar - Updating active tab state');
                self.showTab(visibleTabs[0]);
            }
        }

        function onJoinRequestPopoverClicked() {
            if (self.isCompactMode) {
                $rootScope.$broadcast('enable-compact-mode', false);
                $scope.firebird.sidebarToggle.left = false;
            }
            if (!self.isVisible()) {
                $scope.firebird.sidebarToggle.left = !$scope.firebird.sidebarToggle.left;
            }

            self.showTab('attendee-list');
            onJoinRequestPopoverClose();
            self.hasNewJoinRequests = false;
            $scope.$broadcast('on-scroll-attendee-list-up');
        }

        function onJoinRequestPopoverClose() {
            self.showNewJoinRequestsPopover = false;
        }

        function onJoinRequestsUpdate(e, data) {
            if (data && data.added) {
                if (attendeeService.getIsHost()) {
                    joinRequestNotificationService.reset();
                }

                self.showNewJoinRequestsPopover = !isAttendeeListVisible();
                self.hasNewJoinRequests = self.showNewJoinRequestsPopover;
                if (self.showNewJoinRequestsPopover && self.meetingNoteReminderIsOpen) {
                    self.meetingNoteReminderIsOpen = false;
                    self.onCloseMeetingNoteNotice();
                }
                digest();
            } else if (meetingService.getJoinRequests().length === 0) {
                self.showNewJoinRequestsPopover = false;
                self.hasNewJoinRequests = false;
                digest();
            }
        }

        function isAttendeeListVisible() {
            return self.isVisible() && self.isTabActive('attendee-list');
        }

        function onUpdateLocalMeetingLocked() {
            if (meetingService.getLocked()) {
                if (attendeeService.getIsHost()) {
                    joinRequestNotificationService.start();
                }
            } else {
                if (attendeeService.getIsHost()) {
                    joinRequestNotificationService.stop();
                }

                if (self.showNewJoinRequestsPopover || self.hasNewJoinRequests) {
                    self.showNewJoinRequestsPopover = false;
                    self.hasNewJoinRequests = false;
                    digest();
                }
            }
        }

        function onAttendeeListUpdated(e, data) {
            if (data && data.displayCount) {
                self.attendeeCount = data.displayCount;
                digest();
            }
        }

        function onNotifyMeetingChatMessagesCleared(evt, data) {
            logService.log('chatCtrl - meeting chat cleared by host');
            $rootScope.$broadcast('cleared-meeting-chat-messages');
            if (!attendeeService.getIsHost()) {
                var notificationMessage = localizationService.translate('SIDEBAR.NOTIFICATIONS.CHAT_CLEARED');
                if (!self.isCompactMode) {
                    growlService.show(notificationMessage, 'success');
                }
                notificationService.tryShowDesktopNotification(notificationMessage);
            }
        }

        //Private Function
        function userIsAttendeeOnAir() {
            return meetingService.isWebinar() && attendeeService.getIsAttendee() && meetingService.getIsOnAir();
        }

        function canUseMeetingChat() {
            return meetingService.canUseMeetingChat();
        }

        function digest() {
            $scope.$applyAsync();
        }

        function getChatTooltipMessage() {
            if (!this.hasPresenterChat() && this.canUseMeetingChat()) {
                return '';
            }

            if (meetingService.e2eeEnabled()) {
                return localizationService.translate('SECURITY_SETTINGS.TOOLTIP.E2EE_CHAT_DISABLED');
            }

            var tooltipKey = attendeeService.getIsHost()
                ? 'SIDEBAR.HOST_DISABLED_CHAT_HOST_TOOLTIP'
                : 'SIDEBAR.HOST_DISABLED_CHAT_TOOLTIP';
            return localizationService.translate(tooltipKey);
        }

        function onE2EEEnabled(e, data) {
            if (self.isTabActive('chat') || self.isTabActive('meeting-notes')) {
                self.showTab('attendee-list');
            }
        }

        function onNotesRecipientsChanged(e, data) {
            logService.log(`received notes recipients changed payload with new value: ${data.newValue}`);
            if (data.attendantId === attendeeService.getAttendantId()) {
                return;
            }

            self.notesToAllAttendees = data.newValue === 'all';
        }

        function changeNotesRecipients() {
            const newValue = self.notesToAllAttendees ? 'all' : 'hostOnly';
            logService.log(`changing notesRecipients to ${newValue}`);
            analyticsWrapperService.eventTrack(`Meeting - sidebar - host changed notes recipients to: ${newValue}`);
            const msgObject = {
                message: 'set-notes-recipients',
                data: {
                    newValue
                },
                callback: response => {}
            };

            socketService.send(msgObject);
        }

        function getNotesRecipientsAttendeeTooltip() {
            return self.notesToAllAttendees
                ? localizationService.translate('SECURITY_SETTINGS.NOTES_SENDING.ATTENDEE_SENDING_ENABLED')
                : localizationService.translate('SECURITY_SETTINGS.NOTES_SENDING.ATTENDEE_SENDING_DISABLED');
        }

        function getIsHost() {
            return attendeeService.getIsHost();
        }

        function onCompactModeReceived(e, data) {
            self.isCompactMode = data;

            if (meetingService.getCompactModeAvailable()) {
                if (self.isCompactMode === true && self.isVisible()) {
                    self.toggleSidebarJS();
                }

                if (self.isCompactMode === false && !self.isVisible()) {
                    self.toggleSidebarJS();
                }
            }
        }

        function shouldShowNotificationBadgeOnAttendeesTab() {
            return self.hasNewJoinRequests || self.hasNewRaisedHands;
        }

        function onHandRaised(e, data) {
            self.hasNewRaisedHands = !self.isAttendeeListVisible();
        }

        function onRaisedHandsUpdated(e, data) {
            if (
                !self.isAttendeeListVisible() &&
                data &&
                (data.raisedHands.length === 0 ||
                    (data.raisedHands.length === 1 && data.raisedHands[0] === attendeeService.getAttendantId()))
            ) {
                self.hasNewRaisedHands = false;
            }
        }

        function updateTitle() {
            if (helperService.getVDIRef().showCustomTitleBar) {
                vdiService.setVDITitleBarHeader(getWindowMeetingTitle());
            } else {
                $document[0].title = getWindowMeetingTitle();
            }
        }
    }
]);
